import AppMapControl from "./AppMapControl";

export default AppMapControl;
